import type { ActionConfig } from './action';
import type { TitleBarProps } from './titleBar';
import { createStore } from 'cross-state';
import _ from 'lodash';

export const titleBarStore = createStore({
    stack: [] as TitleBarProps[],
    current: {} as Partial<TitleBarProps>,
    actions: [] as ActionConfig<any>[],
});

const getCurrent = (stack: TitleBarProps[]): Partial<TitleBarProps> =>
    Object.assign(
        {},
        ..._(stack)
            .orderBy('priority')
            .map((x) => _.omitBy(x, _.isUndefined))
            .value(),
    );

function setStack(stack: TitleBarProps[]) {
    titleBarStore.set((state) => ({ ...state, stack, current: getCurrent(stack) }));
}

export function addToTitleBar(entry: TitleBarProps) {
    const stack = [...titleBarStore.get().stack, entry];
    const multi = _(stack)
        .groupBy('priority')
        .filter((x) => x.length > 1)
        .value();
    if (multi.length > 0) console.warn('Multiple titles set with same priority!', multi);

    setStack(stack);
}

export function replaceInTitleBar(entry: TitleBarProps, next: TitleBarProps) {
    setStack(titleBarStore.get().stack.map((x) => (x === entry ? next : x)));
}

export function removeFromTitleBar(entry: TitleBarProps) {
    setStack(titleBarStore.get().stack.filter((x) => x !== entry));
}

export function addAction(action: ActionConfig<any>) {
    titleBarStore.set('actions', (actions) => actions.filter((a) => a.id !== action.id).concat(action));
}

export function removeAction(id: string) {
    if (!titleBarStore.get().actions.some((a) => a.id === id)) return;
    titleBarStore.set('actions', (actions) => actions.filter((a) => a.id !== id));
}
